
/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export interface PbiRefreshMessage {
  code?: string;
  message?: string;
  type?: string;
}

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PbiRefreshMessage {
  /// <code> Place custom code between <code> tags
  
  /// </code>
  // Generated code. Do not place code below this line.
}
